export { default as SvgMorph } from './components/SvgMorph'